import { generatePath } from 'react-router-dom';

import urls from '@routes/urls';

export const getInquiryDetailsUrl = (inquiryId: number) =>
  generatePath(urls.inquiryDetails, {
    inquiryId: inquiryId.toString(),
  });

export const getInquiryResponseUrl = (inquiryId: number) =>
  generatePath(urls.inquiryResponse, {
    inquiryId: inquiryId.toString(),
  });
